import styled from 'styled-components';
import { Collapse as AntdCollapse } from 'antd';

export const Collapse = styled(AntdCollapse)``;
